.root {
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.dot,
.root:after {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 50%;
  box-sizing: border-box;
  z-index: 1;
}

.root:after {
  content: '';
  background: radial-gradient(circle, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.5) 50%, rgba(0,0,0,0.5) 100%);
}
